<!-- Multiple Add to Monitoring Zone Modal-->
<template>
  <div>
    <b-modal
      :visible="visible"
      @change="change"
      @show="fillModal"
      ref="modal"
      id="modal-add-to-zone"
      :title="$t('add_to_monitoring_zone.title')"
      :ok-title="$t('add_to_monitoring_zone.button_add_to_zone')"
      :cancel-title="$t('add_to_monitoring_zone.button_cancel')"
      size="lg"
      @ok="handleOk"
    >
     
    <b-row>
      <b-col cols="12">
          
          <div class="ml-2 typo-title" style="color: #009de0;">
            <span><b>{{(this.lamps.length - numeroLampadeInZona) + " " + $t("add_to_monitoring_zone.lamps_selected")}}</b></span>
            <span class=" ml-2" :content="$t('add_to_monitoring_zone.info')" v-tippy="{ placement: 'top', arrow: true }"> <i class="fa fa-1x fa-info-circle" style="color:#009de0"></i></span>
            <span v-if="numeroLampadeInZona != 0" class=" ml-3" style="color: #8a8787;"><b> {{ numeroLampadeInZona  + " " + $t("add_to_monitoring_zone.lamps_unavailable") }}</b></span>
          </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <table class="table tabLampadeSelectedMonitor mt-3">
          <thead>
              <tr>
                <th style="width:20%">ID</th>
                <th style="width:20%">{{ $t('details_lamp.lamp_desc')}}</th>
                <th style="width:20%">System</th>
                <th style="width:20%">Central</th>
                <th style="width:20%">Zone</th>
              </tr>
          </thead>
          <tbody> 
              <tr v-for="(lamp,index) in this.lampadeConZona" :key="index" :style="{color: (lamp.zone == null) ? '#009de0' : '#8a8787'}">
                  <td style="width:20%"><strong>{{lamp.id}}</strong></td>
                  <td style="width:20%">{{lamp.desc}}</td>
                  <td style="width:20%">{{lamp.cu_type}}</td>
                  <td style="width:20%">{{lamp.cu_id.split("#")[1]}}</td>
                  <td  style="width:20%">{{lamp.zone}}</td>                  
              </tr>
          </tbody>
        </table>

        <div class="ml-2 mt-4 mb-4">  
          <h6>{{$t("add_to_monitoring_zone.label_select_zone")}}</h6>
          <b-form-select v-model="zoneSelected" class='mt-2'>
            <option :value="null" disabled>{{$t("add_to_monitoring_zone.placeholder")}}</option>
            <option v-for="(selectOption, indexOpt) in this.zones" 
              :key="indexOpt"
              :value="selectOption"
            >
            {{ selectOption.zoneName }}
            </option>
          </b-form-select>
        </div>  
      </b-col>
    </b-row>

    </b-modal>

  </div>

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AddToMonitoringZone",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    lamps: {
      default: []
    },
    visible: {
      type: Boolean,
      default: false
    },
    alerts:{
      default: []
    },
  },
  data() {
    return {
      lampSerial: "",
      lampDesc: "",
      spinner: false,
      zones: null,
      timerTimeout: 5,
      lampadeInUnaZona: 0, //numero di lampade già presenti in una zona
      zoneSelected: null,
      pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES
    };
  },
  emits: ['hide', 'change', 'updated-zone'],
  computed: {
    ...mapState(['loading','commandResponse']),

    //verifico se le lampade sono già presenti in qualche zona di monitoraggio
    //output: array di oggetti con id, desc, cu_type, cu_id, zone
    lampadeConZona() {
      //il rendering html avviene prima che siano pronti i dati da remoto, quindi devo aspettare che le zone siano arrivate
      if (this.zones == null) {
        return this.lamps;
      } else {
        var lampadeConZona = [];
        this.lamps.forEach(lamp => {
          let zonaTrovata = null;
          let trovato = false;
          this.zones.some((zone) => {
              zone.lamps.some((lampInZone) => {
                if (lampInZone.id == lamp.id && lampInZone.cu_id == lamp.cu_id) {
                  zonaTrovata = zone.zoneName;
                  trovato = true;
                }
                return trovato;
              });
              return trovato;
          })
          lampadeConZona.push({id: lamp.id, desc: lamp.desc, cu_type: lamp.cu_type, cu_id: lamp.cu_id, zone: zonaTrovata });
        });
        return lampadeConZona;
      }
    },
    //output: numero di lampade selezionate già presenti in una zona di monitoraggio
    numeroLampadeInZona() {
      return this.lampadeConZona.filter(lamp => lamp.zone != null).length;
    },
    //output: array con le lampade che non sono già presenti in una zona di monitoraggio
    lampadeDisponibili() {
      return this.lampadeConZona.filter(lamp => lamp.zone == null);
    }

  },
  watch: {
    loading(val, oldval) {
      if (val != oldval) {
        this.zones = this.$store.state.monitoringZones;
        console.log("Loaded zones ", this.zones);
      }
    },
    // commandResponse(val) {
    //   console.log("cambiata commandResponse ->", val);
    //   if(val.command == "updateMonitoringZone") {
    //     //aggiorno le zone di monitoraggio dopo le aggiunte fatte
    //     this.$store.dispatch("loadPlantMonitoringZones", this.$store.state.currentPlant.id);
    //     //segnalo che tutto è andato a buon fine
    //     var alert = {
    //         timeLeft: 5,
    //         state: "success",
    //         msg: this.$t("add_to_monitoring_zone.lamps_added"),
    //         countDownChanged: function (cd)
    //         {
    //             //timeLeft = cd;
    //             console.log("countdownchanged:" + cd)
    //         }
    //     }
    //     this.alerts.push(alert);
    //     //segnalo che ho eseguito l'aggiornamento
    //     this.$emit("updated-zone");
    //   }        
    // }

  },
  methods: {
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    fillModal() {
      this.zoneSelected = null;
      this.$store.dispatch("loadPlantMonitoringZones", this.$store.state.currentPlant.id);
    },
    handleOk(bvModalevent) {
      var alert;
      // get lamp to monitor and push in array lamps zone
      if (this.zoneSelected != null) {
        if (this.lampadeDisponibili.length == 0) {
          alert = {
              timeLeft: 5,
              state: "danger",
              msg: 'ERROR: ' + this.$t("add_to_monitoring_zone.no_lamps_available"),
              countDownChanged: function (cd)
              {
                  //timeLeft = cd;
                  console.log("countdownchanged:" + cd)
              }
          }
          this.alerts.push(alert);
        }
        else {
          //segnalo che aggiungerò solo le lampade libere
          if (this.numeroLampadeInZona > 0) {
            bvModalevent.preventDefault(); //evito la chiusura
            this.$bvModal.msgBoxConfirm(this.$t("add_to_monitoring_zone.only_lamps_available") , {
              okVariant: 'success',
              centered: true
            })
              .then(value => {
                if (value) {
                  //aggiorno la zona di monitoraggio
                  this.updateMonitoringZone();
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
          else {
            //aggiorno la zona di monitoraggio
            this.updateMonitoringZone();
          } 
        }
      } 
      else {
        //segnalo che non è stata selezionata la zona di monitoraggio
        alert = {
          timeLeft: 5,
          state: "warning",
          msg: this.$t("add_to_monitoring_zone.no_zone_selected"),
          countDownChanged: function (cd)
          {
            //timeLeft = cd;
            console.log("countdownchanged:" + cd)
          }
        }
        this.alerts.push(alert);        
      }
    },
    //effettua fisicamente l'aggiornamento della zona di monitoraggio
    updateMonitoringZone() {
      console.log("Actual monitoring zone: ", this.zoneSelected);

      var updatedZone={};
      var lampToMonitor = {};

      updatedZone.creationTimestamp = this.zoneSelected.creationTimestamp;
      updatedZone.plantId = this.zoneSelected.plantId;
      updatedZone.zoneId = this.zoneSelected.zoneId;
      updatedZone.zoneName = this.zoneSelected.zoneName;
      updatedZone.zoneNumber = this.zoneSelected.zoneNumber;
      updatedZone.lamps = [];

      //in case of monitoring zone not empty, I add the lamps already present
      if (this.zoneSelected.lamps.length > 0) {
        this.zoneSelected.lamps.forEach(lampPresent => {
          updatedZone.lamps.push(lampPresent);
        });
      }
      //add new lamps to monitor
      this.lampadeDisponibili.forEach(element => {
        lampToMonitor = { id: element.id, cu_id: element.cu_id };
        updatedZone.lamps.push(lampToMonitor);
      });

      console.log("Updated monitoring zone: ", updatedZone);

      this.$store.dispatch("updateMonitoringZone", updatedZone);
      //chiudo il modal
      this.$nextTick(() => {
        this.$bvModal.hide('modal-add-to-zone')
      });
    }
  }
}

</script>
